import Image from 'next/image'
import Link from 'next/link'
import parse from 'html-react-parser'

function Catalogues({ list }) {


    return (

        // at this point, we have an array of the catalogues
        list.data.map((catalog) => (
            <div key={catalog.id} className="bg-white rounded shadow flex">
                <div className="w-1/3 bg-img-catalogue border-r border-gray-300">
                    {catalog.media.map((media) => (
                        (media.mime_type == "image/png" || media.mime_type == "image/jpeg") ? (
                            <Image
                                src={media.original_url}
                                alt={catalog.name}
                                width={process.env.NEXT_PUBLIC_SMALL_IMAGE_WIDTH}
                                height={process.env.NEXT_PUBLIC_SMALL_IMAGE_HEIGHT}
                                className="bg-white w-full object-contain"
                                placeholder="blur"

                                blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
                            />
                        ) : ('')
                    ))}
                </div>
                <div className="w-2/3 flex flex-col justify-between p-5">
                    <div>
                        <h3 className="font-bold text-2xl text-gray-900 mb-4">{catalog.title}</h3>
                        <div className="text-gray-600">
                            {(catalog.description) ? (
                                parse(catalog.description)
                            ) : ('')}
                        </div>
                    </div>
                    <div>

                        {catalog.media.map((media) => (
                            (media.mime_type == "application/pdf") ? (
                                <Link key={media.id} href={media.original_url}>
                                    <a target="_blank" rel="noopener noreferrer" className="text-brand-primary text-sm underline font-semibold">Download</a>
                                </Link>
                            ) : ('')
                        ))}


                    </div>
                </div>
            </div>

        ))
    );
}

export default Catalogues;